export const STATES = {
  LAUNCH: 'LAUNCH',
  READY: 'READY',
  SELECTED: 'SELECTED',
  CLEAR_ALL: 'CLEAR_ALL',
  INITIALIZED: 'INITIALIZED',
  START_FIELDS_FILLED: 'START_FIELDS_FILLED',
  DONE_FIELDS_FILLED: 'DONE_FIELDS_FILLED',
  EMPTY_FIELDS: 'EMPTY_FIELDS',
  START_DESELECTION: 'START_DESELECTION',
};

export const ACTIONS = {
  INITIALIZE_CONFIG: 'INITIALIZE_CONFIG',
  SELECT: 'SELECT',
  CLEAR_ALL: 'CLEAR_ALL',
  DESELECT: 'DESELECT',
  FILL_FIELDS: 'FILL_FIELDS',
  FIELDS_FILLED: 'FIELDS_FILLED',
  RESET_FIELDS: 'RESET_FIELDS',
  EMPTY_FIELDS: 'EMPTY_FIELDS',
};
